
<svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M7.79289 1.79289C8.18342 1.40237 8.81658 1.40237 9.20711 1.79289L18.7071 11.2929C19.0976 11.6834 19.0976 12.3166 18.7071 12.7071L9.20711 22.2071C8.81658 22.5976 8.18342 22.5976 7.79289 22.2071C7.40237 21.8166 7.40237 21.1834 7.79289 20.7929L16.5858 12L7.79289 3.20711C7.40237 2.81658 7.40237 2.18342 7.79289 1.79289Z"
    :fill="color"
  />
</svg>
